<script lang="ts" setup>
	/* eslint-disable @typescript-eslint/ban-ts-comment */
	// @ts-nocheck

	import {Button, ButtonVariants} from '@/components/ui/button/index.ts';
	import {PrimitiveProps} from 'radix-vue';
	import {Loader2} from 'lucide-vue-next';
	import {HTMLAttributes} from 'vue';

	interface Props extends PrimitiveProps {
		variant?: ButtonVariants['variant'];
		size?: ButtonVariants['size'];
		class?: HTMLAttributes['class'];
		loading?: boolean;
	}

	const $props = defineProps<Props>();

	const boundProps = computed(() => ({disabled: $props.loading, ...$props}));
</script>

<template>
	<Button v-bind="boundProps">
		<Loader2
			v-if="loading"
			class="h-4 w-4 animate-spin"
		/>
		<slot
			v-else
			name="icon"
		/>
		<slot />
	</Button>
</template>
